import React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import RedeemIcon from '@mui/icons-material/Redeem';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';
import useFreaksT from './useFreaksT';
import { actionSx, FREAKS_GOLD, freaksSx as s } from './freaksStyles';

// Daily prize with a 7-day streak; day 7 pays Freak Points, a freak published today doubles the cash.
export default function FreaksDailyPrize({ daily, busy, onClaim }) {
  const { t } = useFreaksT();
  const Icon = daily.claimable ? CardGiftcardIcon : RedeemIcon;
  return (
    <Box sx={{ ...s.card, borderColor: FREAKS_GOLD, mb: 1.5 }} data-testid="freaks-daily">
      <Box sx={s.between}>
        <Icon sx={{ fontSize: 32, color: FREAKS_GOLD }}/>
        <Box sx={s.grow}>
          <Typography sx={s.title}>
            {t('theFreaks.daily.title')} · {t('theFreaks.daily.streak', { streak: daily.streak })}
          </Typography>
          {daily.claimable ? (
            <Typography>
              {t('theFreaks.daily.prize', { cash: daily.prize.cash, energy: daily.prize.energy })}
              {daily.prize.points ? ` ${t('theFreaks.daily.points', { points: daily.prize.points })}` : ''}
            </Typography>
          ) : (
            <Typography sx={s.muted}>{t('theFreaks.daily.claimed')}</Typography>
          )}
        </Box>
        {daily.claimable ? (
          <Button data-testid="freaks-daily-claim" disabled={busy} onClick={onClaim} sx={actionSx()}>
            {t('theFreaks.daily.claim')}
          </Button>
        ) : null}
      </Box>
      <Box sx={{ display: 'flex', gap: 0.75, mt: 1.25 }}>
        {Array.from({ length: 7 }, (_, index) => (
          <Box
            key={index}
            sx={{
              flex: 1, height: 6, borderRadius: 3,
              backgroundColor: index < (daily.claimable ? daily.streak - 1 : daily.streak) ? FREAKS_GOLD : 'rgba(136,136,136,0.27)',
            }}
          />
        ))}
      </Box>
      {daily.claimable ? (
        <Typography sx={{ mt: 1, fontSize: 12, color: daily.freakBonus ? DEFAULT_THEME_COLOR : 'rgba(255,255,255,0.7)' }}>
          {daily.freakBonus ? t('theFreaks.daily.bonusOn') : t('theFreaks.daily.bonusTip')}
        </Typography>
      ) : null}
    </Box>
  );
}
